import {AppMode, setAppMode as setAppModeState} from './appModeSlice';
import {useSelector} from "react-redux";
import {AppState, useAppDispatch} from "~/state";

export const useAppMode = () => {
  const appMode = useSelector((state: AppState) => state.appMode.mode)
  const dispatch = useAppDispatch()
  const setAppMode = (newAppMode: AppMode) => {
    dispatch(setAppModeState(newAppMode))
  };

  return {
    appMode,
    setAppMode,
  };
};
